module.exports = __webpack_public_path__ + "img/fd_ic_zxkf.8a309ad6.svg";